import { RoutesPaths } from "../../../../constants/RoutePaths";
import { BreadCrumb } from "../../../../models/BreadCrumb";

export const LinkedInBreadcrumbs = {
    LinkedIn: (companyId: number) => {
        return new BreadCrumb(
            "LinkedIn",
            RoutesPaths.Supervision.LinkedInRoutes.BuildStrategyRoute(companyId),
            null
        );
    }
};
